module.exports = __webpack_public_path__ + "img/sanitizerSpraysBottles.8ed49148.png";